export default __webpack_public_path__ + "static/media/giide-publish.e861136e.jpg";